import React ,{useRef}from 'react';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import {
  Box, Paper, FormControl, MenuItem, Select, InputAdornment, OutlinedInput, IconButton, Dialog,
  DialogTitle,
  DialogContent,
  DialogActions, Grid, Divider, Button
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import MaterialTable from 'material-table';
import GetAppIcon from '@material-ui/icons/GetApp';
import CloseIcon from '@material-ui/icons/Close';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
// Importar la librería para exportar a XLSX
import * as XLSX from 'xlsx';
import aprobado from "../../../assets/expediente.png";
import rechazado from "../../../assets/reciborechazado.png";
import reject from "../../../assets/reject.png"; // Asegúrate de que la ruta sea correcta
import success from "../../../assets/success.png"; // Asegúrate de que la ruta sea correcta
import html2canvas from 'html2canvas';
import {encryptData} from '../../../utils/CryptoHandler';
const useStyles = makeStyles(theme => ({
  titleChart: {
    fontWeight: 'bold'
  },
  verticalDivider: {
    margin: theme.spacing(0, 2),
    height: 50,
    backgroundColor: "black",
    width: 2,
  },
  paperMenu: {
    flexGrow: 1,
    background: "transparent",
    boxShadow: 'none'
  },
  tab: {
    minWidth: 200,
    marginRight: theme.spacing(4),
    '&:last-child': {
      marginRight: 0
    }
  },
  root: {
    width: "100%",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        //backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  title: {
    flex: '1 1 100%',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    height: 36,
  },
  formControlSearch: {
    margin: theme.spacing(1),
    minWidth: 250,
  },
  containerOtp: {
    marginTop: theme.spacing(5), // Espacio superior
    width: 'calc(100% - 40%)', // Simula 30% de margen a cada lado (100% - (30% + 30%))
    marginLeft: 'auto',
    marginRight: 'auto',

    [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    
},
titleReferenceBox: {
  display: 'flex',
  justifyContent: 'center',
  // Si quieres que los ítems se centren verticalmente en una fila:
  alignItems: 'center', //
  width: "100%", // Asegura que ocupe todo el ancho disponible

  marginBottom: theme.spacing(3),
  marginTop: -40
},

textoReferencia: {
  fontSize: '1.4rem',
  color: "#F67B40",
  lineHeight: 1.5,
  textAlign: 'center',
},

instructionBox: {
  display: 'flex',
  justifyContent: 'center',
  // Si quieres que los ítems se centren verticalmente en una fila:
  alignItems: 'center', //
  width: "100%", // Asegura que ocupe todo el ancho disponible

  marginBottom: theme.spacing(1),

},

textoData: {
  fontSize: '1.1rem',
  fontWeight: 'bold',
  lineHeight: 1.5,
  textAlign: 'right',
  marginRight: theme.spacing(1), // Espacio entre etiqueta y valor
},
textoDataValue: {
  fontSize: '1.1rem',
  lineHeight: 1.5,
  textAlign: 'left',

  marginLeft: theme.spacing(1), // Espacio entre etiqueta y valor
},

titleSuccess: {
  fontWeight: "bold",
  fontSize: 30,
  marginTop: 20,
  [theme.breakpoints.down("xs")]: {
    fontSize: 20
  }
},
}));

export default function TxReports(props) {
  const classes = useStyles();

  const [tx, setTx] = React.useState([]);
  const [time, setTime] = React.useState('dia');
  const [searchText, setSearchText] = React.useState('');
  const [openDialog, setOpenDialog] = React.useState(false);
  const [selectedTx, setSelectedTx] = React.useState(null);
  const receiptRef = useRef(null);
  React.useEffect(() => {
    
    const fetchData = async () => {
      await getHistoricalTx(props.nombre_usuario, time);
    };
    fetchData();
  }, [time, props.nombre_usuario]);

  const getHistoricalTx = async (nombre_usuario, period) => {
    const header = {};
    try {
      const response = await axios.post(
        process.env.REACT_APP_URL + process.env.REACT_APP_GET_TX,
        { user_plink: nombre_usuario, time: period },
       {
                 headers: {
                   'Authorization': `Bearer ${encryptData(props.token, process.env.REACT_APP_LOGIN_KEY)}`,
                   'id_commerce': encryptData(props.id_commerce, process.env.REACT_APP_LOGIN_KEY)
                 }
               }
      );
      
      if (response.data.exito) {
        const formattedTx = response.data.data.map(item => {
          let statusText;
          if (item.estatus === 1) {
            statusText = 'Aprobada';
          } else if (item.estatus === 2) {
            statusText = 'Rechazada';
          } else {
            statusText = 'Pendiente';
          }

          let fechaObj = item.fecha_tx ? new Date(item.fecha_tx) : null;
          let fecha_sola = fechaObj
            ? fechaObj.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: '2-digit' })
            : '';
          let hora_sola = fechaObj
            ? fechaObj.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
            : '';

          let formattedDate = fechaObj
            ? fechaObj.toLocaleString('es-ES', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true })
            : '';
          let formattedMonto = item.monto !== null ? parseFloat(item.monto).toFixed(2) : '';

          return {
            ...item,
            estatus: statusText,
            fecha_tx: formattedDate,
            monto: formattedMonto,
            fecha_sola,
            hora_sola
          };
        });
        setTx(formattedTx);
        
      }
    } catch (error) {
      console.error('Error al obtener los datos históricos:', error);
      return;
    }
  };

  const columns = [
    { title: 'Fecha', field: 'fecha_sola', defaultSort: 'desc' },
    { 
      title: 'Hora', 
      field: 'hora_sola',
      cellStyle: { whiteSpace: 'nowrap' }, // <-- Esto evita saltos de línea
      headerStyle: { whiteSpace: 'nowrap' }
    },
    { title: 'Referencia', field: 'num_referencia' },
    { title: 'Monto Bs.', field: 'monto' },
    { title: 'Concepto', field: 'motivo' },
    { title: 'Teléfono', field: 'telefono_pagador' },
    { title: 'Banco', field: 'nombre_banco' },
    { title: 'Estatus', field: 'estatus' },
    {
      title: 'Acciones',
      field: 'actions',
      sorting: false,
      render: rowData => (
        <IconButton onClick={() => handleOpenDialog(rowData)}>
          {rowData.estatus === 'Aprobada'
            ? <img src={aprobado} width={24} height={24} alt="Icono de visibilidad" />
            : <img src={rechazado} width={24} height={24} alt="Icono de visibilidad" />}
        </IconButton>
      ),
    }
  ];

  const handleOpenDialog = (tx) => {
    setSelectedTx(tx);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleDownloadVoucher = async () => {
  

    try {
      const canvas = await html2canvas(receiptRef.current, {
        scale: 1, // Mejor calidad de imagen
        backgroundColor: '#ffffff',
        logging: false,
      });

      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = 'comprobante-transaccion.png';
      link.click();
    } catch (error) {
      console.error('Error al generar el comprobante:', error);
      // Aquí puedes agregar manejo de errores (ej: mostrar notificación)
    }
  };

  const handleExportExcel = (data) => {
    
  
    // Crear una nueva versión de los datos sin el campo 'correo'
    const filteredData = data.map(item => {
      const newItem = { ...item }; // Copia el objeto original
      delete newItem.correo; // Elimina la propiedad 'correo'
      return newItem;
    });
  
    const ws = XLSX.utils.json_to_sheet(filteredData); // Usa los datos filtrados
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Transacciones");
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  
    // Create a temporary URL for the Blob and trigger a download
    const url = URL.createObjectURL(dataBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'reporte_transacciones.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url); // Clean up the URL
  };

  return (
    <React.Fragment>
      <Box p={3} maxWidth="100%">
        <Box mt={2}>
          <MaterialTable
  title={
    <Box
      display="flex"
      alignItems="center"
      width="100%"
      style={{ gap: 16, flexWrap: "wrap" }}
    >
      <Typography
        className={classes.title}
        variant="h6"
        id="tableTitle"
        component="div"
        style={{ marginRight: 24, marginTop: 24, whiteSpace: "nowrap" }}
      >
        Transacciones
      </Typography>
      <Box display="flex" alignItems="center" flex="1" style={{ gap: 16 }}>
        <FormControl
          variant="outlined"
          className={classes.formControlSearch}
          style={{ marginRight: 8, flex: "1 1 350px", minWidth: 200, maxWidth: 400 }}
        >
          <OutlinedInput
            id="search-input"
            placeholder='Busca la transacción por cualquier campo'
            variant="outlined"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            }
            style={{ height: 36, fontSize: 15, width: "100%" }}
            onKeyPress={(event) => {
              if (!/[a-zA-Z0-9.,\s]/.test(event.key)) {
                event.preventDefault();
              }
            }}
          />
        </FormControl>
        <FormControl
          variant="outlined"
          className={classes.formControl}
          style={{ minWidth: 120, height: 36 }}
        >
          <Select
            labelId="time-select-label"
            id="time-select-outlined"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            style={{ height: 36, fontSize: 15 }}
            inputProps={{
              style: { paddingTop: 8, paddingBottom: 8 }
            }}
          >
            <MenuItem value={'dia'}>Hoy</MenuItem>
            <MenuItem value={'mes'}>Mes</MenuItem>
            <MenuItem value={'trimestral'}>3 meses</MenuItem>
            <MenuItem value={'semestral'}>6 meses</MenuItem>
            <MenuItem value={'1 año'}>12 meses</MenuItem>
          </Select>
        </FormControl>
        <Button
          variant="contained"
          color="primary"
          startIcon={<GetAppIcon />}
          style={{ height: 36, minWidth: 48 }}
          onClick={() => handleExportExcel(tx.filter(item =>
            item.num_referencia?.toString().toLowerCase().includes(searchText.toLowerCase()) ||
            item.fecha_sola?.toLowerCase().includes(searchText.toLowerCase()) ||
            item.hora_sola?.toLowerCase().includes(searchText.toLowerCase()) ||
            item.monto?.toString().toLowerCase().includes(searchText.toLowerCase()) ||
            item.motivo?.toLowerCase().includes(searchText.toLowerCase()) ||
            item.telefono_pagador?.toLowerCase().includes(searchText.toLowerCase()) ||
            item.nombre_banco?.toLowerCase().includes(searchText.toLowerCase()) ||
            item.estatus?.toLowerCase().includes(searchText.toLowerCase())
          ))}
        >
          Descargar Excel
        </Button>
      </Box>
    </Box>
  }
  columns={columns}
  data={tx.filter(item =>
    item.num_referencia?.toString().toLowerCase().includes(searchText.toLowerCase()) ||
    item.fecha_sola?.toLowerCase().includes(searchText.toLowerCase()) ||
    item.hora_sola?.toLowerCase().includes(searchText.toLowerCase()) ||
    item.monto?.toString().toLowerCase().includes(searchText.toLowerCase()) ||
    item.motivo?.toLowerCase().includes(searchText.toLowerCase()) ||
    item.telefono_pagador?.toLowerCase().includes(searchText.toLowerCase()) ||
    item.nombre_banco?.toLowerCase().includes(searchText.toLowerCase()) ||
    item.estatus?.toLowerCase().includes(searchText.toLowerCase())
  )}
  options={{
    headerStyle: {
      backgroundColor: '#fafafa',
      fontWeight: 'bold',
    },
    pageSize: 10,
    pageSizeOptions: [10, 25, 50, 100],
    emptyRowsWhenPaging: false,
    toolbar: true,
    search: false,
  }}
  localization={{
    pagination: {
      labelDisplayedRows: '{from}-{to} de {count}',
      labelRowsSelect: 'filas',
      labelRowsPerPage: 'Filas por página:',
      firstTooltip: 'Primera página',
      previousTooltip: 'Página anterior',
      nextTooltip: 'Página siguiente',
      lastTooltip: 'Última página',
    },
    toolbar: {
      nRowsSelected: '{0} fila(s) seleccionada(s)',
      searchPlaceholder: 'Buscar',
      searchTooltip: 'Buscar',
      exportTitle: 'Exportar',
      exportAriaLabel: 'Exportar',
      exportCSV: 'Exportar como CSV',
      exportPDF: 'Exportar como PDF',
    },
    header: {
      actions: 'Acciones',
    },
    body: {
      emptyDataSourceMessage: 'No hay registros para mostrar', // This is for "no data"
      filterRow: {
        filterPlaceHolder: 'Filtrar',
        filterTooltip: 'Filtrar',
      },
      addTooltip: 'Añadir',
      deleteTooltip: 'Eliminar',
      editTooltip: 'Editar',
      editRow: {
        deleteText: '¿Estás seguro de que quieres eliminar esta fila?',
        cancelTooltip: 'Cancelar',
        saveTooltip: 'Guardar',
      },
      grouping: {
        placeholder: 'Arrastra encabezados aquí para agrupar',
        groupedBy: 'Agrupado por:',
      },
    },
  }}
/>
        </Box>
      </Box>

      {/* Diálogo para ver el comprobante */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Comprobante de Transacción</Typography>
            <IconButton onClick={handleCloseDialog}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent>
         
        <Grid container className={classes.containerOtp} ref={receiptRef} > {/* Contenedor de cuadrícula para los dos campos inferiores */}
                  {}
                    
                    <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" style={{ width: '100%' }}>
                     {selectedTx && selectedTx.estatus === "Rechazada"?<img src={reject} alt="Imagen de rechazo" style={{ width: 80, height: 80 }} />:<img src={success} alt="Imagen de aprobado" style={{ width: 85, height: 80 }} />} 
                      <Typography className={classes.titleSuccess}>{selectedTx && selectedTx.estatus === "Rechazada"?"Transacción Rechazada":"Transacción aprobada"}</Typography>
                    </Box>  
                     

                    {/* {
                      (!status && messageError !== "" && messageError) && <Typography className={classes.errorMessage}> {messageError}</Typography>
                    } */}



         

<Grid item xs={12} sm={12} style={{ padding: 1, marginTop:50 }} > {/* En pantallas pequeñas ocupa 12 columnas, en medianas y grandes 6 */}
    <Box className={classes.titleReferenceBox}>

        <Typography variant="p" className={classes.textoReferencia} >Referencia : {selectedTx && selectedTx.num_referencia} </Typography>

    </Box>
    <Box className={classes.instructionBox}>
        <Grid item xs={6}>
            <Typography variant="body1" className={classes.textoData}>
                Fecha :
            </Typography>
        </Grid>
        <Grid item xs={6}>

            <Typography variant="body1" className={classes.textoDataValue}>
            {selectedTx && selectedTx.fecha_tx ? selectedTx.fecha_tx.split(',')[0] : ''}
            </Typography>

        </Grid>


    </Box>

    <Box className={classes.instructionBox}>

        <Grid item xs={6}>
            <Typography variant="body1" className={classes.textoData}>
                Hora : 
            </Typography>
        </Grid>
        <Grid item xs={6}>

            <Typography variant="body1" className={classes.textoDataValue}>
            {selectedTx && selectedTx.fecha_tx ? selectedTx.fecha_tx.split(',')[1] : ''}
            </Typography>

        </Grid>



    </Box>

    {/* 6 -7 */}
    <Box className={classes.instructionBox}>
        <Grid item xs={6}>
            <Typography variant="body1" className={classes.textoData}>
                Origen :
            </Typography>
        </Grid>
        <Grid item xs={6}>

            <Typography variant="body1" className={classes.textoDataValue}>
                {selectedTx && selectedTx.telefono_pagador}
            </Typography>

        </Grid>

    </Box>

    <Box className={classes.instructionBox}>
        <Grid item xs={6}>
            <Typography variant="body1" className={classes.textoData}>
                CI/Rif :
            </Typography>
        </Grid>
        <Grid item xs={6}>

            <Typography variant="body1" className={classes.textoDataValue}>
               {selectedTx && selectedTx.cedula }
            </Typography>

        </Grid>

    </Box>

    <Box className={classes.instructionBox}>
        <Grid item xs={6}>
            <Typography variant="body1" className={classes.textoData}>
                Monto:
            </Typography>
        </Grid>
        <Grid item xs={6}>

            <Typography variant="body1" className={classes.textoDataValue}>
              
                {selectedTx && new Intl.NumberFormat('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(selectedTx.monto)} Bs.
            </Typography>

        </Grid>

    </Box>

    <Box className={classes.instructionBox}>
        <Grid item xs={6}>
            <Typography variant="body1" className={classes.textoData}>
                Descripción :
            </Typography>
        </Grid>
        <Grid item xs={6}>

            <Typography variant="body1" className={classes.textoDataValue}>
                {selectedTx && selectedTx.motivo}
            </Typography>

        </Grid>

    </Box>
    
</Grid>




</Grid>


        </DialogContent>

        <DialogActions>

        
          <Button color="primary" style={{marginTop:40, marginRight:20, marginBottom:20}}  startIcon={<GetAppIcon />} onClick={(e) => {handleDownloadVoucher(selectedTx);handleCloseDialog(e)}}>
            Descargar Comprobante
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}



// {selectedTx && (
//   <Box p={2} border={1} borderColor="grey.300" borderRadius={4}>
  
//     <Box textAlign="center" mb={2}>
//       <Typography variant="h6" gutterBottom style={{ fontWeight: 'bold' }}>
//         COMPROBANTE DE PAGO
//       </Typography>
//       <Typography variant="body2" color="textSecondary">
//         Transacción realizada exitosamente
//       </Typography>
//     </Box>

//     {/* Detalles de la transacción */}
//     <Box mb={2}>
//       <Grid container spacing={2}>
//         <Grid item xs={6}>
//           <Typography variant="body2">
//             <strong>Fecha:</strong> {selectedTx.fecha_tx.split(',')[0]}
//           </Typography>
//         </Grid>
//         <Grid item xs={6}>
//           <Typography variant="body2">
//             <strong>Hora:</strong> {selectedTx.fecha_tx.split(',')[1].trim()}
//           </Typography>
//         </Grid>

//         <Grid item xs={12}>
//           <Divider style={{ margin: '8px 0' }} />
//         </Grid>

//         <Grid item xs={12}>
//           <Typography variant="body2">
//             <strong>Destino:</strong> {selectedTx.nombre_banco}
//           </Typography>
//         </Grid>

//         <Grid item xs={12}>
//           <Typography variant="body2">
//             <strong>CI/Rif:</strong> {selectedTx.cedula || 'No disponible'}
//           </Typography>
//         </Grid>

//         <Grid item xs={12}>
//           <Typography variant="body2">
//             <strong>Monto:</strong> {selectedTx.monto} Bs.
//           </Typography>
//         </Grid>

//         <Grid item xs={12}>
//           <Typography variant="body2">
//             <strong>Referencia:</strong> {selectedTx.num_referencia}
//           </Typography>
//         </Grid>

//         <Grid item xs={12}>
//           <Divider style={{ margin: '8px 0' }} />
//         </Grid>

//         <Grid item xs={12}>
//           <Typography variant="body2">
//             <strong>Descripción:</strong> {selectedTx.motivo}
//           </Typography>
//         </Grid>
//       </Grid>
//     </Box>


  //   <Box mt={3} textAlign="center">
  //     <Button
  //       variant="contained"
  //       color="primary"
  //       startIcon={<PictureAsPdfIcon />}
  //       onClick={() => handleDownloadVoucher(selectedTx)}
  //     >
  //       Descargar Comprobante
  //     </Button>
  //   </Box>
  // </Box>
//)}